import { gql } from "@apollo/client";

export const GET_BUSINESS_CATEGORIES = gql`
  query GetBusinessCategories {
    getBusinessCategories {
      id
      name
      slug
      parentCategoryId
      parentCategory {
        id
        name
        slug
        parentCategoryId
      }
      businesses {
        name
        countryId
        displayOnBookingPage
      }
    }
  }
`;
